import type React from 'react'
import { useMemo } from 'react'
import { CHART_COLORS, parseToUnixSeconds } from '../../config/charts'
import { FinancialChart } from './FinancialChart'

interface ShiftChartProps {
    data: any[]
    symbol?: string // Optional if not used
    isLoading?: boolean // Optional
}

export const ShiftChart: React.FC<ShiftChartProps> = ({ data }) => {
    const chartData = useMemo(() => {
        if (!data) return []
        return data
            .map((item) => {
                const time = parseToUnixSeconds(item.timestamp)
                if (time === null) return null

                return {
                    time: time as any,
                    value: item.shift,
                }
            })
            .filter((x) => x !== null) as any[]
    }, [data])

    if (!data || data.length === 0) return null

    return (
        <FinancialChart
            type="Line"
            data={chartData}
            height={250}
            title="Intraday Shift Trend"
            colors={{
                lineColor: CHART_COLORS.PRIMARY,
                areaTopColor: CHART_COLORS.PRIMARY,
                areaBottomColor: 'rgba(67, 56, 202, 0.1)',
            }}
        />
    )
}
